const PREFIX = 'uf/logging';

export const LOG = `${PREFIX}/LOG`;
